import { COLUMN_WIDTHS, CUSTOM_FILTER_TYPE } from "./ApplicationConstants";

export const CUSTOMER_INFORMATION_COL = [
  {
    key: "Shipping Address",
    value: "shippingAddress",
    isFilterEnabled: false,
    filterType: "String",
    customFilterType: CUSTOM_FILTER_TYPE.listBox,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: true,
    width: COLUMN_WIDTHS.large,
  },
  {
    key: "Install Type",
    value: "installType",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Contact",
    value: "contactName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Email",
    value: "email",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Phone",
    value: "phone",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Return Label Contact",
    value: "returnLabelName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Return Label Email",
    value: "returnLabelEmail",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Return Label Phone ",
    value: "returnLabelPhone",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
];

export const WORKTICKET_HISTORY_OVERVIEW_COL = [
  {
    key: "Ticket Type",
    value: "ticketType",
    isFilterEnabled: false,
    filterType: "String",
    customFilterType: CUSTOM_FILTER_TYPE.listBox,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: true,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Status",
    value: "status",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Created On",
    value: "createdOn",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Changed On",
    value: "changedOn",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Modified By",
    value: "modifiedBy",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Created By",
    value: "createdBy",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Distribution Channel",
    value: "distributionChannel",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Return Reason",
    value: "returnReason",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: true,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Requested Delivery Date",
    value: "requestDate",
    isFilterEnabled: false,
    filterType: "String",
    customFilterType: CUSTOM_FILTER_TYPE.listBox,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: true,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Owner",
    value: "ownerName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Status Date",
    value: "modifiedAt",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Customer Contract Account",
    value: "contractAccount",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Sales Org",
    value: "salesOrg",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "Division",
    value: "division",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
  {
    key: "CRM Reference ID",
    value: "crmReferenceId",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: COLUMN_WIDTHS.small,
  },
];
